import React from "react";

// การ์ดสรุปผลตรวจโปรวันเกิด
// ใช้ 2 ที่: หน้า "โปรวันเกิด" (ค้นหาเอง) และแท็บ customfield ในหน้าจัดการเคส
// กติกา/ตัวเลขทั้งหมดมาจาก backend (PROMO_RULES) ที่เดียว — ที่นี่แค่เอามาวาด
export const money = (v) =>
  v == null || v === ""
    ? "-"
    : Number(String(v).replace(/,/g, "")).toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

const CheckMark = ({ ok }) => (
  <span style={{ fontSize: 18, color: ok ? "#237804" : "#cf1322", fontWeight: 700 }}>
    {ok ? "✅" : "❌"}
  </span>
);

const PromoRow = ({ label, value, ok, highlight }) => (
  <tr>
    <td style={{ border: "1px solid #d9d9d9", padding: "6px 10px", background: "#fafafa" }}>{label}</td>
    <td
      style={{
        border: "1px solid #d9d9d9",
        padding: "6px 10px",
        textAlign: "center",
        fontWeight: 700,
        background: highlight ? "#ffffb8" : "#fff",
      }}
    >
      {value}
    </td>
    <td style={{ border: "1px solid #d9d9d9", padding: "6px 10px", textAlign: "center", width: 70 }}>
      <CheckMark ok={ok} />
    </td>
  </tr>
);

const PromoCard = ({ promo, member }) => {
  const r = promo.rules;
  return (
    <div
      style={{
        background: "#fff",
        color: "#212121",
        borderRadius: 10,
        marginBottom: 16,
        maxWidth: 520,
        overflow: "hidden",
        border: "1px solid #d9d9d9",
      }}
    >
      <div style={{ background: "#595959", color: "#fff", padding: "10px 16px", fontSize: 18, fontWeight: 700, textAlign: "center" }}>
        โปรวันเกิด MGB-USA
      </div>

      <div style={{ padding: "12px 16px" }}>
        <div style={{ textAlign: "center", fontWeight: 700, marginBottom: 8 }}>
          🎉 รับเครดิตฟรี {r.creditAmount} บาท สำหรับฉลองวันเกิด 🎉
        </div>
        <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
          <li>เป็นสมาชิกอย่างน้อย {r.minMembershipDays} วัน</li>
          <li>มีรายการฝากอย่างน้อย {r.minDepositDays} วัน ใน 1 เดือน</li>
          <li>ยอดฝากรวม {r.minTotalAmount.toLocaleString("th-TH")} บาท</li>
          <li>พร้อมบัตรประชาชน</li>
        </ol>
        <div style={{ color: "#cf1322", fontSize: 12, textAlign: "center", marginTop: 10, lineHeight: 1.6 }}>
          กรณีมียอดฝากขาดไม่เกิน {r.shortfallAllowance} สามารถแจ้งลูกค้า
          ให้ฝากเพิ่มให้ครบตามเงื่อนไข แล้วจึงรับโปรวันเกิดได้
        </div>
      </div>

      <div style={{ background: "#595959", color: "#fff", padding: "6px 16px", fontWeight: 700, textAlign: "center" }}>
        ตรวจสอบโปรวันเกิด
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
        <tbody>
          <PromoRow
            label={<span>ชื่อ-สกุล <span style={{ color: "#cf1322", fontSize: 12 }}>(ไม่ใส่ผู้แนะนำ)</span></span>}
            value={member?.fullName || "-"}
            ok={!!member?.fullName}
          />
          <PromoRow
            label="วันที่สมัคร"
            value={
              <>
                {promo.registeredAt ? promo.registeredAt.slice(0, 10) : "-"}
                <div style={{ fontSize: 11, fontWeight: 400, color: "#8c8c8c" }}>
                  เป็นสมาชิกมา {promo.membershipDays ?? "-"} วัน
                </div>
              </>
            }
            ok={promo.checks.membership}
            highlight
          />
          <PromoRow
            label="จำนวนวันที่ฝาก / วัน"
            value={promo.depositDays}
            ok={promo.checks.depositDays}
          />
          <PromoRow
            label="ฝากทั้งหมด"
            value={
              <>
                {money(promo.totalAmount)}
                {promo.shortfall > 0 && (
                  <div style={{ fontSize: 11, fontWeight: 400, color: "#cf1322" }}>
                    ขาดอีก {money(promo.shortfall)} บาท
                    {promo.canTopUp ? " (แจ้งลูกค้าฝากเพิ่มได้)" : ""}
                  </div>
                )}
              </>
            }
            ok={promo.checks.amount}
          />
        </tbody>
      </table>

      <div
        style={{
          padding: "10px 16px",
          textAlign: "center",
          fontSize: 18,
          fontWeight: 700,
          background: promo.passed ? "#d9f7be" : "#fff1f0",
          color: promo.passed ? "#237804" : "#cf1322",
        }}
      >
        {promo.passed ? "✅ ผ่าน" : "❌ ไม่ผ่าน"}
      </div>
    </div>
  );
};

export default PromoCard;
